import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import {
  FormBuilder,
  FormControl,
} from '@angular/forms';
// import { NgForm } from '@angular/forms';
import { ModalController, NavController,ActionSheetController } from '@ionic/angular';

import { DataService } from 'src/app/services/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationExtras } from '@angular/router';

@Component({
  selector: 'app-view-category',
  templateUrl: './view-category.component.html',
  styleUrls: ['./view-category.component.scss'],
})

export class ViewCategoryComponent implements OnInit {
// @Input() categoryAdd = { category_name: '', description: '' }
  // submitted: boolean;
  category:any={};
  title= 'Add';
  // @Input() title:any;
  // @Input() type:any;
  // @Input() category:any={}
  submitted= false;
  // categoryForm: FormGroup;
  categoryimagedata:any;
  categoryfile:any;
  // category_image;
  category_detail:any 
  current_value = 'category_info'




  // dynamic json

  sidebar = [
    {
      title : 'Product Info',
      name : 'product_info',
      icon: ''
    },
    {
      title : 'Images',
      name : 'images',
      icon: ''
    },
    {
      title :   'Inventory',
      name : 'inventory',
      icon: ''
    },
    {
      title : 'Category Mapping',
      name : 'category_mapping',
      icon: ''
    },
    {
      title :   'Shipping Info',
      name : 'shipping_info',
      icon: ''
    },
    // {
    //   title :  'Brands',
    //   name : 'brands',
    //   icon: ''
    // },
    // {
    //   title : 'Model',
    //   name : 'modal',
    //   icon: ''
    // },
    {
      title : 'Variants',
      name : 'variants',
      icon: ''
    },
    // {
    //   title : 'Specifications',
    //   name : 'specifications',
    //   icon: ''
    // },
    // {
    //   title :   'Promotions',
    //   name : 'promotions',
    //   icon: ''
    // },
    {
      title : 'SEO',
      name : 'seo',
      icon: ''
    },

   
    
  ]


  
  form_data:any =  [
    {
      group_title : 'Category Info',
      mapped_by:'category_info',
      group_fileds :[
            {
              label :'Category Name',
              input_type: 'input',
              type : 'text',
              name :'category_name',
              placeholder : '',
              required : true,
              hidden: false,
              value : '',
              tooltip: 'Category Name'
            },
            {
              label :'Display Order',
              input_type: 'input',
              type : 'text',
              name :'display_order',
              placeholder : '',
              required : true,
              hidden: false,
              value : '',
              tooltip: 'Display Order'
            },
            // {
            //   label :'Product Image Size',
            //   input_type: 'input',
            //   type : 'text',
            //   name :'product_image_size',
            //   placeholder : '',
            //   required : false,
            //   hidden: false,
            //   value : ''
            // },
            {
              label :'Is Active?',
              input_type: 'checkbox__',
              type : 'text',
              name :'is_active',
              placeholder : '',
              required : false,
              hidden: false,
              value : 0
            },
            {
              label :'Display Home Page',
              input_type: 'checkbox__',
              type : 'text',
              name :'display_home_page',
              placeholder : '',
              required : false,
              hidden: false,
              value : 0
            },
            {
              label :'Show Attributes in List Page',
              input_type: 'checkbox__',
              type : 'text',
              name :'is_bundle_itemshow_attributes_inline',
              placeholder : '',
              required : false,
              hidden: false,
              value : 0
            },
            // {
            //   label :'Default View',
            //   input_type: 'dropdown',
            //   type : 'ionic',
            //   name :'default_view',
            //   placeholder : '',
            //   required : false,
            //   hidden: false,
            //   value : 'Grid View',
            //   dropdown_options :[
            //     {
            //       text : 'Grid View'
            //     },
            //     {
            //       text : 'List View'
            //     },
            //   ]
            // },
            {
            label : "Default View",
            input_type: 'dropdown',
            type : 'text',
            name :'default_view',
            placeholder : 'Default View',
            required : false,
            hidden: false,
            value : 'Grid View',
            options:[{'name':'Grid View'},{'name':'List View'}],
            tooltip: '',
            },
      ]
    },
            {
              group_title : 'Images',
              mapped_by:'category_info',
              group_fileds : [
                {
                  label :'Category Image',
                  input_type: 'input',
                  type : 'file',
                  name :'category_image',
                  placeholder : '',
                  required : false,
                  hidden: false,
                },
              ]
            },
            {
              group_title : 'Is Group',
              mapped_by:'category_info',
              group_fileds : [
                {
                  label :'Is Group',
                  input_type: 'checkbox__',
                  type : 'text',
                  name :'is_group',
                  placeholder : '',
                  required : false,
                  hidden: false,
                  value:0
                }
              ]
            },
            {
              group_title : 'SEARCH ENGINE OPTIMISATION (SEO)',
              mapped_by:'category_info',
              group_fileds : [
                {
                  label :'Meta Title',
                  input_type: 'input',
                  type : 'text',
                  name :'meta_title',
                  placeholder : '',
                  required : false,
                  hidden: false,
                },
                {
                  label :'Meta Keywords',
                  input_type: 'input',
                  type : 'text',
                  name :'meta_keywords',
                  placeholder : '',
                  required : false,
                  hidden: false,
                },
                {
                  label :'Meta Description',
                  input_type: 'input',
                  type : 'text',
                  name :'meta_description',
                  placeholder : '',
                  required : false,
                  hidden: false,
                }
              ]
            }
    
  ]


  attributes : any = [ 
    'Dropdown List',
    'Radio Button List',
    'Checkbox List',
    'Color Boxes',
    'Text Box',
    'Table',
    'Multi Line Text'
  ]

 



  constructor(private actionSheetCtrl: ActionSheetController,private navCtrl: NavController,private activeRoute: ActivatedRoute,private router: Router,public formBuilder: FormBuilder,public modalCtrl: ModalController,public DBservice: DataService,private route:ActivatedRoute) {

  // this.activeRoute.queryParams.subscribe((params) => {
  //     let navParams = this.router.getCurrentNavigation().extras.state;
  //     if (params && params.) {
  //       this.title = 'Edit'
  //       this.get_category_detail(params.id);
  //     }
  //   });

   }

  ngOnInit() {
    this.category.default_view = 'Grid View';

    // this.route.params.subscribe(res =>{
    //   // console.log(res);
    //   if(res && res.category_id){
    //       this.get_category_detail(res.category_id);
    //   }
    // })

    this.activeRoute.queryParams.subscribe((params:any) => {
      // let navParams = this.router.getCurrentNavigation().extras.state;
      if (params && params.id) {
        this.title = 'Edit'
        this.get_category_detail(params.id);
      }
    });

    let v = {}
    this.form_data.map(res =>{
      res.group_fileds.map(op =>{
        v[op.name] = new FormControl( op.value ,[])
      })
    })

    this.category =  this.formBuilder.group(v)
  // 	this.categoryForm = this.formBuilder.group({
  //     category_name: new FormControl((this.category.category_name || ''), Validators.required),
  //     // description: new FormControl((this.category.description || ''), Validators.required),
  //     // category_image: new FormControl((this.category.category_image || ''), Validators.required)
  //   });
  //   console.log(this.categoryForm)
  //  // this.categoryForm.category_name = new FormControl('', Validators.required);
  //  // this.categoryForm = new FormGroup({
  //  //   category_name: new FormControl('', Validators.required)
  //  // });
  }

  async selectImageSource() {
    // const buttons = [
    //   {
    //     text: 'Take Photo',
    //     icon: 'camera',
    //     handler: () => {
    //       this.takePicture();
    //     }
    //   },
    //   {
    //     text: 'Choose From Photos Photo',
    //     icon: 'image',
    //     handler: () => {
    //       // this.addImage(CameraSource.Photos);
    //     }
    //   }
    // ];
    // const actionSheet = await this.actionSheetCtrl.create({
    //   header: 'Select Image Source',
    //   buttons
    // });
    // await actionSheet.present();
  }

  async takePicture() {
    // let myImage;
    // const image = await Camera.getPhoto({
    //   quality: 90,
    //   allowEditing: true,
    //   resultType: CameraResultType.Base64, // Uri , Base64, DataUrl
    //   source: CameraSource.Camera
    // });

    // myImage = image.webPath;
    // this.categoryimagedata = myImage;
    // // console.log(myImage)
  }

  get_category_detail(id){
     var data = {
      name:id,
      doctype:'Product Category'
    }
    this.DBservice.get_doc_list(data)
      .subscribe((data:any) => {
          // console.log(data.message)
          if(data.message != undefined)
            // this.category = data.message;
            this.category_detail = data.message;
            this.load_product_Values();
         }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

  

  close_category(form){
     this.submitted = true;

    //  console.log(form,'---------------------')
    if(form.valid){
       
        var data={
          name:this.category_detail.name ? this.category_detail.name : '',
          category_name:form.value.category_name ? form.value.category_name : this.category.value.category_name,
          description:form.value.description ? form.value.description :this.category.value.description,
          is_active:form.value.is_active ? form.value.is_active :this.category.value.is_active,
          product_category_name : form.value.product_category_name ? form.value.product_category_name :this.category.value.category_name,
          display_home_page : form.value.display_home_page ? form.value.display_home_page :this.category.value.display_home_page,
          display_order : form.value.display_order ? form.value.display_order :this.category.value.display_order,
          product_image_size : form.value.product_image_size ? form.value.product_image_size :this.category.value.product_image_size,
          show_attributes_inline : form.value.show_attributes_inline ? form.value.show_attributes_inline :this.category.value.show_attributes_inline,
          default_view : form.value.default_view ? form.value.default_view :this.category.value.default_view,
          domain:localStorage['active_domain'],

        }

        // console.log(data,'----------------');

        this.title == 'Edit' ? this.insert_category(data,'Category Updated Successfully','Edit') : this.insert_category(data,'Category Added Successfully','Add')

        
      }
      // else
         
        // this.insert_category(this.category,'Category Added Successfully','Add')
    
  }

  insert_category(category,text,type){



    
    this.DBservice.add_menu_category(category,type)
      .then(res => {
        console.log(res)
        if(res.message.status == 'failed')
          {
            var d = JSON.parse(res._server_messages);
            var d1 = JSON.parse(d);
            // this.DBservice.alert(d1.message)
          }
          else{
            
            this.navCtrl.pop()
            this.upload_files(res)
            this.DBservice.alert(text);
          }
        // this.modalService.dismissAll()
        // this.get_categorylist();
      })
    }

    upload_files(res){
    // upload_files(category,text,type){
    // this.DBservice.add_menu_category(category,type)
    //   .subscribe(res => {
       
        // if(this.categoryimagedata != undefined && this.categoryfile != undefined){
          let img_name =  this.DBservice.driver_proofs[0].filename;
          let file_data = this.DBservice.driver_proofs[0].content;
          var imagedata={
            "products":[
              {
                // "parentfield":"product_images",
                "fieldname":"category_image",
                "filename":img_name,
                "doctype":"Product Category",
                "docname":res.message.name,
                "filedata":file_data
              }
            ]
          }
         
          this.DBservice.uploadfiles(imagedata).subscribe(res => {
            this.DBservice.driver_proofs = [];
            if (res._error_message) {
              // console.log(res._error_message)
              // this.DBservice.alert(res._error_message)
            }
          })
        // }
      // })
  }


  load_product_Values(){
    // console.log(this.category_detail)
    Object.keys(this.category.controls).map((frm_cntl)=>{
      Object.keys(this.category_detail).map((res_key)=>{
        // || (frm_cntl == 'mobile_image' && res_key == 'mobile_image' )
        if(frm_cntl == res_key ){
          // console.log(frm_cntl ,res_key);
          // console.log(this.category_detail[res_key]);
          if(frm_cntl == 'mobile_image' && res_key == 'mobile_image' ){
            // this.category.append("mobile_image",this.category_detail[res_key])
            // this.category.get(frm_cntl).setValue({'fileName':(this.category_detail[res_key])})
          }else{
            this.category.get(frm_cntl).setValue(this.category_detail[res_key])
          }
        }
        
      })
    })
  }


}
